import { renderProductFamilyTemplate } from '../../util/BlockUtil';

export const ProductFamilyTemplate = ({
  data,
  type,
  lang,
  global,
  width,
  popular_downloads_posts,
  related_content,
  tags,
}) => {
  return (
    <div className={type.replace(/\s/g, '')}>
      {renderProductFamilyTemplate({
        data: data,
        width,
        lang,
        global,
        categories: data.categories,
        locations: data.locations,
        popular_downloads_posts,
        related_content,
        tags,
      })}
    </div>
  );
};
